import React, { useEffect } from 'react';
import BookingFieldsBlock from './BookingFieldsBlock';
import Price from './Price';
import TimeZone from '../../components/Common/TimeZone';
import VariantsBlock from './VariantsBlock';
import { stringToBoolean } from '../../utilities/conversionUtility';

export default function RentalConfirmationPage(props) {
  const {
    allDay,
    canBook,
    closeModal,
    dateFormat,
    enabledBookingFields,
    enableLocationDropdown,
    enableResourceDropdown,
    getValidationFn,
    locale,
    price,
    productTitle,
    renderSubmitButton,
    selectedDateRange,
    selectedLocation,
    selectedResource,
    selectedVariant,
    setting,
    setWrapperHeight,
    style,
    timeInterval,
    timeZone,
    translation,
  } = props;

  const selectedStart = selectedDateRange ? selectedDateRange.start : null;

  useEffect(() => setWrapperHeight(), []);

  return (
    <div>
      <button type="button" className="btn-back-title" style={style.body} onClick={closeModal}>
        <i className="fa fa-arrow-left fa-2" aria-hidden="true" />
      </button>

      <h3 className="text-center widget-title" style={{ ...style.title, minHeight: '16px' }}>
        {translation.key('modalTitle')}
      </h3>

      <p className="mt0 description-title">{translation.key('descriptionModal')}</p>
      <div>
        <VariantsBlock
          productTitle={productTitle}
          variants={[selectedVariant]}
          selectedTimeSlot={selectedDateRange}
          selectedResource={selectedResource}
          selectedLocation={selectedLocation}
          locale={locale}
          timeZone={timeZone}
          isDisableFinishDate={!stringToBoolean(setting.include_returned_date)}
          isHideTime={!stringToBoolean(setting.show_time_picker)}
          timeFormat={setting.time_format}
          selectDifferentTime={closeModal}
          enableResourceDropdown={enableResourceDropdown}
          enableLocationDropdown={enableLocationDropdown}
          allDay={allDay}
          style={style}
        />
        {enabledBookingFields
          && (
          <BookingFieldsBlock
            translation={translation}
            getValidationFn={(validationFn) => getValidationFn(validationFn)}
            willUpdate={() => setWrapperHeight()}
            timeZone={timeZone}
            timeInterval={timeInterval}
            dateFormat={dateFormat}
          />
          )}
        <TimeZone timeZone={timeZone} selectedTime={selectedStart} className="mt15" />
        <Price price={price} style={{ ...style.body }} title={translation.key('price')} />
      </div>
      <div>
        {renderSubmitButton(canBook)}
      </div>
    </div>
  );
}
